export default __webpack_public_path__ + "static/media/hero-spacer.8f4a6876.svg";